import { Organization } from '../../apis/graphql/types';

export const organization: Organization = {
  id: 'organization-id-1',
  createdAt: '2021-08-01T00:00:00Z',
  crmLink: 'https://hulusales--dev23.sandbox.my.salesforce.com/a3uKQ000000DZaUYAW',
  disabledReason: null,
  isBaymaxEnabled: false,
  lastLoginAt: '2021-08-01T00:00:00Z',
  name: 'Organization Demo',
  address: {
    city: 'Nashville',
    country: 'USA',
    line1: '1601 Herman Street',
    line2: '',
    state: 'TN',
    zipCode: '37208',
  },
  phoneNumber: '+1 (123) 456-7890',
  operatesAsAgency: false,
  status: 'ACTIVE',
  threepBillingEligible: false,
};
